<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Cadastrar dados bancários'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>
              <v-layout align-center justify-center>
                <v-flex xs10>

                  <v-layout justify-space-between>
                    <v-flex xs5>
                      <v-text-field
                        label='Nome do banco'
                        v-model="dadosBancarios.nomeBanco"
                        required
                        :rules="regrasBasicas"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-text-field
                        label='Número do banco'
                        v-model="dadosBancarios.numeroBanco"
                        required
                        :rules="regrasBasicas"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout justify-space-between>
                    <v-flex xs3>
                      <v-text-field
                        label='Agência'
                        v-model="dadosBancarios.agencia"
                        required
                        :rules="regrasBasicas"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        label='Conta'
                        v-model="dadosBancarios.conta"
                        required
                        :rules="regrasBasicas"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        label='Código de Operação'
                        v-model="dadosBancarios.codigoOperacao"
                        required
                        :rules="regrasBasicas"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap center>
                    <v-flex xs12>
                      <v-radio-group
                        style="margin-left: 10px"
                        v-model="dadosBancarios.tipoConta"
                        label="Tipo de conta:"
                        required
                        :rules="regrasBasicas"
                        row
                      >
                        <v-radio label="Conta Corrente" value="C" style="margin-left: 10px"></v-radio>
                        <v-radio label="Poupança" value="P" ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>


                  <br>

                  <div class="black--text text-justify text-h6">

                    Eu, {{bolsista.nomePessoa.toUpperCase()}}, comprometo-me a cumprir as atividades relacionadas à bolsa vinculada a ação de extensão {{bolsista.nomeProjeto.toUpperCase()}} pelo
                    período de {{this.dates.format(bolsista.dataInicio)}} a {{this.dates.format(bolsista.dataFim)}}, apresentando os relatórios semestrais de atividade obrigatórias
                    do bolsista e de acordo com as normas vigentes no edital.

                    <v-layout row wrap center class="justify-center">
                      <v-radio-group v-model="concordo" row center>
                        <v-radio label="Concordo" :value="true" ></v-radio>
                        <v-radio label="Não concordo" :value="false" ></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </div>

                </v-flex>
              </v-layout>
            </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="salvar" :disabled="!formularioValido || !concordo">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import bolsas from '@/utils/bolsas'
  import dates from '@/utils/dates'
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      dates: dates,
      formularioValido: false,
      concordo: false,
      dadosBancarios: {},
      bolsista: {},
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      criarBolsa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' })
        bolsas.postBolsa(this.bolsa.unidade.id, this.bolsa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ListaBolsas'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsista.' })
      bolsas.getBolsista()
      .then(response => {
        this.bolsista = response.data
      })
      .catch(error => {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsista.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip
    }
  }
</script>



// WEBPACK FOOTER //
// dados-bancarios.vue?16166f19